/**
 * Application Constants
 * This file contains constants and configuration values used throughout the application
 */

export const industries = [
    'Accountants/ CPA\'s',
    'Adult Entertainment',
    'Animal Hospital/ Veterinarian',
    'Antiques',
    'Appliance Sales',
    'Architecture',
    'Art Galleries',
    'Arts & Crafts',
    'ATM Services',
    'Auction, Appraisal & exchange services',
    'Automotive Customization',
    'Automotive Repair',
    'Automotive Sales',
    'Bail Bondsmen',
    'Bakeries',
    'Bar & Grill',
    'Bar/Pub',
    'Beauty Shops',
    'Bike Store',
    'Bridal/ Wedding',
    'Carwash',
    'Catering',
    'Cellular Store',
    'Chiropractor',
    'Clothing Store',
    'Clothing Wholesale',
    'Collection Agency',
    'Consignment',
    'Convenience Store',
    'Dentist',
    'Digital Advertising/Media Groups',
    'Doctor',
    'Dry Cleaning',
    'Electricians',
    'Electronics',
    'Engineering/Design',
    'Equipment Rentals/Sales',
    'Excavation work',
    'Farming',
    'Flooring',
    'Florist',
    'Freight Brokers/Logistics',
    'Funeral Homes',
    'Furniture store/sales',
    'Gambling/Casino',
    'Gas Station',
    'Gift Shops',
    'Golf',
    'Grocery / Supermarket',
    'Gun Shop',
    'Gym',
    'Healthcare',
    'Heating & Air Conditioning',
    'Home Builders',
    'Home Health Care',
    'Home Improvement',
    'Hospices',
    'Hotel',
    'Import/Export',
    'Insurance',
    'Interior Design',
    'Janitorial/Cleaning',
    'Jewelry Store',
    'Landscaping',
    'Law Firm/ Lawyers',
    'Lawn Mower Repair',
    'Lead Generation',
    'Learning Institutions',
    'Limousine/Taxi Company',
    'Liquor store',
    'Livestock',
    'Lumber & Wood Products',
    'Mailing/ Shipping',
    'Mattress Sales',
    'Medical Transportation/Ambulances',
    'Mining',
    'Miscellaneous Personal Services',
    'Miscellaneous Repair Services (other)',
    'Miscellaneous Retail Store (Retail)',
    'Moving & Storage',
    'Nutritional products/ supplements',
    'Other (Advertising & Marketing)',
    'Other (automotive)',
    'Other (Construction)',
    'Other (Consulting)',
    'Other (Entertainment)',
    'Other (Environmental Services)',
    'Other (Financial Services)',
    'Other (Food & Beverage)',
    'Other (Hospitality)',
    'Other (Manufacturing)',
    'Other (Medical)',
    'Other (Professional Services)',
    'Other (Real estate)',
    'Other (Recreation)',
    'Other (Security Services)',
    'Other (Service)',
    'Other (Software/Technology)',
    'Other (Telecommunications)',
    'Other (Tradesworkers)',
    'Other (Trucking)',
    'Other (wholesale)',
    'Painters',
    'Parking Garages',
    'Paving/ Sealing/ Concrete',
    'Pawn Shops',
    'Pest Control',
    'Pet supplies',
    'Pharmacy',
    'Plumbing',
    'Printing(have equipment)',
    'Property Management Company',
    'Radio/Television',
    'Real Estate Investment',
    'Real Estate Rentals',
    'Real Estate Sales',
    'Restaurant',
    'Restaurant (Quick Service/Fast Food)',
    'Roofing Siding & Sheet Metal Work',
    'Salon',
    'Salon/ Spa/ Hair/ Nails',
    'Shoe Stores',
    'Sporting Goods Stores',
    'Staffing Service',
    'Steakhouse',
    'Syndicating Partner',
    'Tanning Salon',
    'Tire Shop',
    'Tobacco/Smoke Shops',
    'Towing',
    'Toy Stores/Hobby Shops',
    'Transmission shop',
    'Travel Agency',
    'Waste Disposal/ Recycling / Trash Recycling',
    'Wholesale Beer & Beverage',
    'Wholesale Electronics',
    'Wholesale Food Distributors'
];

// Export other constants as needed 